import React from 'react';
import { PictureAsPdf } from '@mui/icons-material';
import { ArtifactType } from '@/common/const';
import { useHttpContext } from '@/common/hooks/HttpContext';
import { toasts } from '@/common/toasts';
import { Button } from '@/components/common/button/button';
import { resultIsError } from '@/services/HttpService';

interface ScanSessionReportActionProps {
    sessionUUID: string;
}

export const ScanSessionReportAction = ({ sessionUUID }: ScanSessionReportActionProps) => {
    const { httpService } = useHttpContext();
    const { errorToast, warningToast } = toasts;

    const handleClick = async () => {
        // Open synchronously within the click handler so the popup blocker doesn't swallow it after the await
        const reportWindow = window.open('', '_blank');
        const res = await httpService.adminGetScanSessionArtifactSignedUrl(sessionUUID, ArtifactType.SessionReport);
        if (resultIsError(res)) {
            reportWindow?.close();
            errorToast(`Could not load session report. ${res.message || ''}`);
            return;
        }
        if (!res) {
            reportWindow?.close();
            warningToast('Session report is still generating. Try again shortly.');
            return;
        }
        if (reportWindow) {
            reportWindow.location.href = res;
        } else {
            window.location.href = res;
        }
    };

    return (
        <Button onClick={handleClick} startIcon={<PictureAsPdf />} variant="secondary" size="small">
            Report
        </Button>
    );
};
